import React from 'react';

import { colors, Row, Col, SegmentedControl, Typography } from '@ajaibid/components';
import { FORM_OPTIONS } from '@context/stock/buysell';

import { useStockBuySellContext } from '../../hooks';

const SwitchOrderPeriod = () => {
  const { code, formState, formKey, formAction, dispatch, isCreate, isAmend } =
    useStockBuySellContext();

  return (
    <Row noGutters align="between" marginTop={12}>
      <Col size="auto">
        <Typography type="body" bold margin={0}>
          Periode
        </Typography>
      </Col>
      <Col size="auto">
        {isCreate && (
          <SegmentedControl
            style={{ width: 120 }}
            segments={FORM_OPTIONS.ORDER_PERIOD}
            value={formState[formKey.INPUT_ORDER_PERIOD]?.value}
            onChange={(v) => dispatch({ type: formAction.CHANGE_ORDER_PERIOD, code, payload: v })}
            data-testid="switch-orderPeriod"
          />
        )}
        {isAmend && (
          <Typography type="body" color={colors.NEUTRAL_7} margin={0} data-testid="txt-orderPeriod">
            {formState[formKey.INPUT_ORDER_PERIOD]?.label}
          </Typography>
        )}
      </Col>
    </Row>
  );
};

export default SwitchOrderPeriod;
